import { createSelector } from "reselect";
import { ORB_DOMAIN } from "./constants";


const selectORBDomain = state => {
  return state[ORB_DOMAIN] || initialState;
}

export function selectORBStock(){
  return createSelector(selectORBDomain, (ORB) => {
    return ORB.stock
  })
}

export function selectIncoming(){
  return createSelector(selectORBDomain, (ORB) => {
    return ORB.incoming
  })
}
